import axios from 'axios';
import { Dispatch } from 'react';
import { attachTokenToHeaders } from '../auth/actions';
import { NavigateFunction } from 'react-router-dom';
import { logOutUser, loadMe } from '../auth/actions';
import { RootState } from 'store/reducers';
import { ProfileActions, UserActionTypes } from './types';
import { AuthActions } from 'store/auth/types';
import { GlobalActions, GlobalActionTypes } from 'store/global/types';

type ActionTypes = GlobalActions | ProfileActions;

export const editUser =
  (id: number, formData: FormData, navigate: NavigateFunction) =>
  async (dispatch: Dispatch<ActionTypes | typeof loadMe>, getState: () => RootState) => {
    dispatch({ type: GlobalActionTypes.LOADING });
    try {
      const options = attachTokenToHeaders(getState, true);
      const response = await axios.put(`/api/users/${id}`, formData, options);

      dispatch({
        type: UserActionTypes.EDIT_USER_SUCCESS,
        payload: { user: response.data.user },
      });
      dispatch({
        type: GlobalActionTypes.SUCCESS_LOAD,
      });

      navigate('/profile', { state: { message: 'Your profile has been successfully updated' } });
    } catch (err: any) {
      dispatch({
        type: GlobalActionTypes.MESSAGE_FAIL,
        payload: { error: err?.response?.data.message || err.message },
      });
    }
  };

export const getProfile =
  () => async (dispatch: Dispatch<ActionTypes>, getState: () => RootState) => {
    dispatch({ type: GlobalActionTypes.LOADING });
    try {
      const options = attachTokenToHeaders(getState);
      const response = await axios.get(`/api/users/me`, options);
      dispatch({
        type: UserActionTypes.GET_PROFILE_SUCCESS,
        payload: { profile: response.data.me },
      });
      dispatch({
        type: GlobalActionTypes.SUCCESS_LOAD,
      });
    } catch (err: any) {
      dispatch({
        type: GlobalActionTypes.MESSAGE_FAIL,
        payload: { error: err?.response?.data.message || err.message },
      });
      if (err?.response.status === 404) {
        //  history.push('/notfound');
      }
    }
  };

export const deleteUser =
  (id: number) =>
  async (
    dispatch: Dispatch<ActionTypes | ((a: Dispatch<AuthActions | GlobalActions>) => void)>,
    getState: () => RootState,
  ) => {
    dispatch({ type: GlobalActionTypes.LOADING });
    try {
      const options = attachTokenToHeaders(getState);
      const response = await axios.delete(`/api/users/${id}`, options);
      if (getState().auth.me!.id === response.data.user.id) {
        dispatch(logOutUser());
      }
      dispatch({
        type: UserActionTypes.DELETE_USER_SUCCESS,
        payload: { message: response.data.user },
      });
      dispatch({
        type: GlobalActionTypes.SUCCESS_LOAD,
      });
    } catch (err: any) {
      dispatch({
        type: GlobalActionTypes.MESSAGE_FAIL,
        payload: { error: err?.response?.data.message || err.message },
      });
    }
  };
